<template>
    <div>
        <h4 class="display-1">{{text}} </h4>
    </div>
</template>

<script>

export default {
  name: 'Inspire',
  props: ['items'],
  data () {
    return {
      text: ''
    }
  },
  created () {
    let i = 0
    this.text = this.items[i]
    this.updater = setInterval(() => {
      i += 1
      if (this.items.length === i) {
        i = 0
      }
      this.text = this.items[i]
    }, 8000)
  },
  destroyed () {
    clearInterval(this.updater)
  }
}

</script>

<style lang="scss" type="text/scss">

</style>
